import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Segment, Message, Label } from "semantic-ui-react";

import { toolTipManager } from '../../services/instanceService';
import { RESET_PASSWORD_TOOL_TIP_ID } from '../../constants';
import ToolTip from "../../components/tool_tip/tool_tip";

import { resetPassword } from "../../actions/password/reset";
import SystemHeader from "../../components/system_header";
import "../../App.css";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      invalidEmailError: false,
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
    };

    this.isFormSubmitted = false;
  }

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  onReset = () => {
    const isValid = this.validateEmail(this.state.email);
    if (!isValid) {
      this.setState({ invalidEmailError: true });
      return;
    }

    this.setState({ invalidEmailError: false });
    this.isFormSubmitted = true;
    this.props.reset(this.state.email);
  };

  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value,
      invalidEmailError: false,
    });
  };

  render() {
    const { reset_description, email_placeholder, submit_button, login_button_text, reset_email_trigger_message, enter_valid_email_format } = this.state.translations;
    const isMessageShown = this.isFormSubmitted && !this.props.pending;
    const isFormShown = !isMessageShown;

    const resetTip = toolTipManager.getById(RESET_PASSWORD_TOOL_TIP_ID);
    const { features } = this.props.instanceConfig || {};

    return (
      <div>
        <SystemHeader showLanguage={false} />
        <div className="reset-password-form">
          <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="middle">
            <Grid.Column className={isMessageShown ? "reset-password-message-wide" : "reset-password-message-narrow"}>
              {isFormShown && (
                <div>
                  <Header as="h2" color="teal" textAlign="center">
                    <div className="reset-password-header-content">
                      {reset_description}
                      { features && features.tool_tips && resetTip && (
                        <div className="circle-tool-tip-wrapper">
                          <ToolTip
                            title={resetTip.title}
                            description={resetTip.description}
                            video={resetTip.video_link}
                          />
                        </div>
                      )}
                    </div>
                  </Header>
                  <Form size="large">
                    <Segment>
                      <Form.Input
                        fluid
                        icon="user"
                        iconPosition="left"
                        placeholder={email_placeholder}
                        type="email"
                        error={this.state.invalidEmailError}
                        onChange={this.handleEmailChange}
                      />
                      {this.state.invalidEmailError && (
                        <Message
                          negative
                          size="small"
                          content={enter_valid_email_format}
                        />
                      )}
                      <Button
                        loading={this.props.pending}
                        color="teal"
                        fluid
                        size="large"
                        onClick={this.onReset}
                      >
                        {submit_button}
                      </Button>
                    </Segment>
                  </Form>
                </div>
              )}
              {isMessageShown && (
                <Header as="h4" color="teal" textAlign="center" className="reset-password-message-header">
                  <p>{reset_email_trigger_message}</p>
                  <Button color="teal" href="/">
                    {login_button_text}
                  </Button>
                </Header>
              )}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    resetFailure: state.reset_password.resetFailure,
    pending: state.reset_password.pending,
    language: state.language.language,
    languages: state.language.languages,
    instanceConfig: state.instance.instanceConfig,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset: (email) => {
      dispatch(resetPassword(email));
    },
  };
};

let ResetPasswordPage = connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/views/password/reset.js